import React from "react";

import { Box, Container, Grid, Link, Typography } from "@mui/material";

import { globalVariables } from "../../global/GlobalVariables";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function Support(params) {
  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid
          container
          sx={{
            gap: 2,
            p: 2,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Typography variant="h3" gutterBottom>
              Support
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Typography variant="body1" paragraph>
              Need help? We have a Support page to help answer questions
            </Typography>
            <Typography variant="body1" paragraph>
              <Link href={globalVariables()?.site?.supportUrl} target="_blank">
                {globalVariables()?.site?.supportUrl}
              </Link>
            </Typography>
            <Typography variant="body1" paragraph>
              Have any other questions? Email us:
            </Typography>
            <Typography variant="body1" paragraph>
              <Link
                href={`mailto:${
                  getEnvironmentVariable("COMPANY_SUPPORT_EMAIL") ||
                  "support@bestcoastpairings.com"
                }`}
                underline="none"
              >
                {getEnvironmentVariable("COMPANY_SUPPORT_EMAIL") ||
                  "support@bestcoastpairings.com"}
              </Link>
            </Typography>
            {getEnvironmentVariable("COMPANY_SUGGESTIONS_EMAIL") && (
              <>
                <Typography variant="body1" paragraph>
                  Have any suggestions or comments? Email us:
                </Typography>

                <Typography variant="body1" paragraph>
                  <Link
                    href={`mailto:${
                      getEnvironmentVariable("COMPANY_SUGGESTIONS_EMAIL") ||
                      "suggestions@bestcoastpairings.com"
                    }`}
                    underline="none"
                  >
                    {getEnvironmentVariable("COMPANY_SUGGESTIONS_EMAIL") ||
                      "suggestions@bestcoastpairings.com"}
                  </Link>
                </Typography>
              </>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
